import RatedTag from './RatedTag'

export default RatedTag
